import React, { useRef, useState } from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ItemsApp from './ItemsApp';
import QRCode, { QRCodeSVG } from "qrcode.react";
import { toPng, toSvg } from "html-to-image";
import { Button } from '@mui/material';
import { handleRequestError } from '../../services/api';
import { useDispatch } from 'react-redux';

export default function QrCodesPage() {

    const dispatch = useDispatch()

    const printRef = useRef<HTMLDivElement>(null)

    const [qrCodesCount, setQrCodesCount]= useState<number>(154)
    const [includeItemUniqueId, setIncludeItemUniqueId] = useState<boolean>(true)

    const [width, setWidth] = useState<number>(125)

    const itemsApp = new ItemsApp()

    const qrCodes = Array.from({ length: qrCodesCount }, (_, i) => itemsApp.generateUniqueId())

    // const handleSaveAsPDF = async (): Promise<void> => {
    //     if (!printRef.current) return;
    
    //     try {
    //       const element = printRef.current;
    
    //       // Use html2canvas to capture the element as a canvas
    //       const canvas = await html2canvas(element, { scale: 2 }); // High resolution
    //       const imgData = canvas.toDataURL('image/png');
    
    //       // Initialize jsPDF
    //       const pdf = new jsPDF('p', 'mm', 'a4');
    //       const imgWidth = 210; // A4 width in mm
    //       const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
    
    //       // Add image to the PDF
    //       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    //       pdf.save('qr-codes-list.pdf');
    //     } catch (error) {
    //       console.error('Failed to save as PDF', error);
    //     }
    // };
    const handleSaveAsPDF = async (): Promise<void> => {
        if (!printRef.current) return;
    
        try {
          const element = printRef.current;
    
          // Use html2canvas to capture the element as a canvas
          const canvas = await html2canvas(element, { scale: 2 }); // High resolution
          const imgData = canvas.toDataURL('image/png');
    
          // Initialize jsPDF
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210; // A4 width in mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
    
          // Add image to the PDF
          pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          pdf.save('qr-codes-list.pdf');
        } catch (error) {
          console.error('Failed to save as PDF', error);
        }
    };


    return(
        <div className="qr-codes-items-page">
            <PageHeadSection pageName="qrcodes" customActionButtons={[
                {
                    icon: "download",
                    label: "Download PDF",
                    onClick: () => handleSaveAsPDF()
                },
            ]} />

            <div className="qr-codes-list-a4-container">
                <div 
                    className="a4-page-container" 
                    ref={printRef}
                >
                    <div className="content-of-a4-page-container">
                        <div className="printed-qr-codes-container">
                            {qrCodes.map((qr, index) => (
                            <div className="item-qr-code">
                                    <div className="content-of-item-qr-code">
                                        <QRCodeSVG value={qr} size={width} level="H" />
                                        {includeItemUniqueId && <h3>{qr}</h3>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="buttons-box-of-qr-codes-list-a4-container">
                <div className="content-of-buttons-box-of-qr-codes-list-a4-container">
                    <Button onClick={() => setIncludeItemUniqueId(includeItemUniqueId ? false : true)} className="general-button admin-style light-button" color={includeItemUniqueId ? "error" : "success"} variant="contained">{includeItemUniqueId ? "Hide Unique ID" : "Show Unique ID"}</Button>
                </div>
            </div>

        </div>  
    )
}